import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./Services/Store/Store";

import { REACT_APP_GOOGLE_CLIENT_ID } from "./utils/env";

const root = ReactDOM.createRoot(document.getElementById("root"));

console.log("REACT_APP_GOOGLE_CLIENT_ID :", REACT_APP_GOOGLE_CLIENT_ID);

if (process.env.NODE_ENV === "development") {
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
} else {
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
